import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { validate as isUuid } from 'uuid';

import {
  selectCompanyEntities,
  selectDisableMFASwitch,
  selectIsAdmin,
  selectIsAuthenticated,
  selectNeedsToSetUpMfa,
} from '../../redux/selectors';

const handleParamsValidation = (paramsToValidate, params) => {
  return Object.keys(paramsToValidate).every((p) => {
    const type = paramsToValidate[p];

    switch (type) {
      case 'uuid':
        return isUuid(params[p]);

      default:
        return false;
    }
  });
};

const PrivateRoute = ({
  children,
  companyEntities,
  component: Component,
  disableMFASwitch,
  isAdmin,
  isAuthenticated,
  needsToSetUpMfa,
  paramsToValidate,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const { params, url } = props.match;
        const shouldValidateParams = paramsToValidate && Object.keys(paramsToValidate)?.length > 0;
        const paramsAreValid = shouldValidateParams && handleParamsValidation(paramsToValidate, params);

        if (!isAuthenticated) {
          return <Redirect to={{ pathname: '/login', from: props.location }} />;
        } else {
          if (shouldValidateParams && !paramsAreValid) {
            return <Redirect to="/not-found" />;
          }

          if (needsToSetUpMfa && !(url.startsWith('/settings') || disableMFASwitch)) {
            return <Redirect to="/settings/security" />;
          } else if (companyEntities && isAdmin && props.location.pathname !== '/settings/advanced') {
            return <Redirect to="/settings/advanced" />;
          } else {
            return <Component {...props} {...rest} />;
          }
        }
      }}
    />
  );
};

const mapStateToProps = (state) => ({
  companyEntities: selectCompanyEntities(state),
  disableMFASwitch: selectDisableMFASwitch(state),
  isAdmin: selectIsAdmin(state),
  isAuthenticated: selectIsAuthenticated(state),
  needsToSetUpMfa: selectNeedsToSetUpMfa(state),
});

export default connect(mapStateToProps)(PrivateRoute);
